import { jsx } from "react/jsx-runtime";
import { Text } from "@wix/wix-ui-tpa/cssVars";
import { classes } from "../../../file-upload/file-upload-wut.st.css";
import { FileList } from "./components/FileList.js";
import { DATA_HOOKS } from "./dataHooks.js";
import { classes as classes$1 } from "./FileUpload.st.css";
const FileUploadDetails = ({
  fileInputRef,
  textBelowButtonRef,
  files,
  onDeleteClick,
  hasError,
  explanationText
}) => {
  const filesExist = files && Boolean(files.length);
  if (filesExist) {
    return /* @__PURE__ */ jsx("div", { className: classes.root, children: /* @__PURE__ */ jsx(
      FileList,
      {
        files,
        explanationText,
        fileInputRef,
        textBelowButtonRef,
        onDeleteClick,
        hasError
      }
    ) });
  }
  if (explanationText) {
    return /* @__PURE__ */ jsx("div", { className: classes.root, children: /* @__PURE__ */ jsx(
      Text,
      {
        "data-hook": DATA_HOOKS.explanation,
        className: classes$1.explanation,
        children: explanationText
      }
    ) });
  }
  return null;
};
export {
  FileUploadDetails
};
//# sourceMappingURL=FileUploadDetails.js.map
